<div class="app-input">
  <mat-form-field [formGroup]="group" floatLabel="always" class="full-width-field">
    <mat-label [innerHTML]="field.displayName"></mat-label>
    <mat-select placeholder="---None---" [formControlName]="field.name">
        <mat-option *ngFor="let item of field.possibleValues" (onSelectionChange)="updateVisibility($event, item)" [value]="item.value">{{item.name}}</mat-option>
    </mat-select>
    <ng-container *ngFor="let validation of field.validations;" ngProjectAs="mat-error">
        <mat-error *ngIf="group.controls[field.name].hasError(validation.name.toLowerCase())">{{validation.message}}</mat-error>
    </ng-container>
</mat-form-field>
</div>
